import { render, staticRenderFns } from "./ClientiView.vue?vue&type=template&id=e4e4df80&"
import script from "./ClientiView.ts?vue&type=script&lang=ts&"
export * from "./ClientiView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports